import { useDispatch, useSelector } from 'react-redux';
import { selectGLLimit } from '../../../../selectors/application';
import { setRestaurantCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { formatCurrency } from '../../../../helpers/formatNumber';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const RestaurantCoverageSummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const glLimit = useSelector(selectGLLimit) || 0;

  const coverageInfo = [
    { coverage: 'Food Contamination', limit: '$10,000' },
    { coverage: 'Additional Advertising Expenses', limit: '$3,000' },
    { coverage: 'Spoilage', limit: '$10,000' },
    { coverage: 'Reward Payment', limit: '$5,000' },
    { coverage: 'Brands and Labels', limit: formatCurrency(glLimit) },
    { coverage: 'Ordinance and Law', limit: formatCurrency(glLimit) },
    { coverage: 'Lock Replacement', limit: '$1,000' },
    { coverage: 'Delivery Errors and Omissions', limit: '$10,000' },
    { coverage: 'Merchandise withdrawal Expense', limit: '$25,000' },
  ];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.RestaurantCoverage, false));
    dispatch(setRestaurantCoverage(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.RestaurantCoverage, true));
    dispatch(setRestaurantCoverage(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Food Service Coverage"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default RestaurantCoverageSummaryCard;
